import CareConciergContactForm from '@/features/provider-directory/components/CareConciergContactForm';
import type { PageOrigin } from '@/features/provider-directory/components/CareConciergContactForm/types';
import { ServiceCoordinationCallButton } from '@/shared/components/ServiceCoordinationCallButton';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/shared/components/ui/dialog';

type ConciergeContactModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /**
   * Where the request came from. Defaults to the QA-tab value this modal was built for, so its
   * original caller keeps reporting exactly what it always did.
   */
  pageOrigin?: PageOrigin;
  /**
   * Feature 137: offer the service coordination call ahead of the form. Off where the caller has
   * just offered it and the advisor chose the form instead.
   */
  offerCall?: boolean;
};

export const ConciergeContactModal = ({
  open,
  onOpenChange,
  pageOrigin = 'provider-directory-no-results',
  offerCall = true,
}: ConciergeContactModalProps) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-h-[90vh] max-w-4xl overflow-y-auto bg-background p-4 sm:p-6">
      <DialogHeader>
        <DialogTitle className="text-2xl font-recoleta font-semibold text-[#111827]">
          Contact Care Concierge
        </DialogTitle>
        <DialogDescription className="text-sm font-termina text-gray-600">
          {offerCall
            ? 'Book a free 15-minute service coordination call with our Care Concierge team, or complete this form and someone from the team will reach out to help coordinate next steps.'
            : 'Complete this form and someone from our Care Concierge team will reach out to help coordinate next steps.'}
        </DialogDescription>
      </DialogHeader>
      {/* Feature 137: every caller is on the FA dashboard, and the embedded form hides its own
          header — so the call is offered here, ahead of the form. */}
      {offerCall && (
        <ServiceCoordinationCallButton variant="default" size="sm" className="justify-self-start" />
      )}
      <CareConciergContactForm
        sourceContext="navigator"
        pageOrigin={pageOrigin}
        className="mt-0"
        embedded
      />
    </DialogContent>
  </Dialog>
);
